import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { AbTestProgram } from './ab-test-program.model'

export class AbTest extends BaseModel<AbTest> {
  static DEFAULT_ATTRIBUTES = {}

  id: number
  name: string
  status: string
  centerId: number
  abTestPrograms: AbTestProgram[]
  createdAt: Moment
  startedAt: Moment
  finishedAt: Moment

  get statusCaption(): string {
    if (this.isStarted) {
      return "Запущен"
    } else if (this.isNotStarted) {
      return "Не запущен"
    } else if (this.isPaused) {
      return "На паузе"
    } else if (this.isFinished) {
      return "Закончен"
    }
  }

  get isNotStarted(): boolean {
    return this.status == "not_started"
  }

  get isStarted(): boolean {
    return this.status == "started"
  }

  get isFinished(): boolean {
    return this.status == "finished"
  }

  get isPaused(): boolean {
    return this.status == "paused"
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/ab-test.model.ts